import Dashboard from '@pages/Dashboard';
import Reconciliation from '@pages/Reconciliation';
import BDXValidationReport from '@pages/BDXValidationReport';

export default [
  {
    path: '/dashboard/:report_id?',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      permissions: [
        {
          role: 'Guest',
          access: false,
          redirect: 'Home',
        },
      ],
      flexContainer: true,
    },
  },
  {
    // The Converted dropdown's "Reconciliation Report" always renders the
    // native RecProductionReport component directly — unlike Dashboard, it's
    // not keyed off a report_id/report-name match, so it can't collide with
    // the backend-driven "FCP Report Production" entry under My Reports.
    path: '/reconciliation',
    name: 'Reconciliation',
    component: Reconciliation,
    meta: {
      permissions: [
        {
          role: 'Guest',
          access: false,
          redirect: 'Home',
        },
      ],
      flexContainer: true,
    },
  },
  {
    // Native rebuild of the "BDX Validation Report" Power BI page (LIQ-1954),
    // static data for now - see BDXValidationReport.vue.
    path: '/bdx-validation-report',
    name: 'BDXValidationReport',
    component: BDXValidationReport,
    meta: {
      permissions: [
        {
          role: 'Guest',
          access: false,
          redirect: 'Home',
        },
      ],
      flexContainer: true,
    },
  },
];
